import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoyaltyProgramsModel } from '@models/index';
import {
  CountriesInt,
  VisaTypeInt,
  RelationShipTypeInt,
  AnswerHavanaTypeInt,
  TimaticTypeInt,
  GenderTypeInt,
  StayTypeInt,
} from "@app/interfaces/";

@Injectable({
  providedIn: 'root'
})
export class LocalDataService {
  url: string = "../../assets/data/resources";
  countries: CountriesInt[] = [];
  bagRules:any = [];
  relationShip:RelationShipTypeInt[] =[]
  gendersTypes:any = [];
  loyaltyPrograms:any = [];
  timaticType: any = [];
  constructor(private http: HttpClient) { }

  getLoyaltyPrograms( ): Observable<Array<LoyaltyProgramsModel>> {
    return this.http.get<LoyaltyProgramsModel[]>(`${ this.url }/loyaltyPrograms.json`, {}).pipe(
      map (( res ) => res.map((data) => {
        const program = new LoyaltyProgramsModel(data);
        this.loyaltyPrograms = program
        return program;
      })
    )
  );
  }

  getCountries( ): Observable<Array<CountriesInt>> {
    return this.http.get<CountriesInt[]>(`${ this.url }/countries.json`, {});
  }

  getBagsRules( ): Observable<Array<any>> {
    return this.http.get<any[]>(`${ this.url }/bagRules.json`, {});
  }

  getVisaType( ): Observable<Array<VisaTypeInt>> {
    return this.http.get<VisaTypeInt[]>(`${ this.url }/visaType.json`, {});
  }

  getTimaticStay( ): Observable<Array<TimaticTypeInt>> {
    return this.http.get<TimaticTypeInt[]>(`${ this.url }/timaticType.json`, {});
  }

  getUsPersonStay( ): Observable<Array<TimaticTypeInt>> {
    return this.http.get<TimaticTypeInt[]>(`${ this.url }/usPersonStay.json`, {});
  }

  getRelationShipType( ): Observable<Array<RelationShipTypeInt>> {
    return this.http.get<RelationShipTypeInt[]>(`${ this.url }/relationships.json`, {});
  }

  getAnswersHavanaType( ): Observable<Array<AnswerHavanaTypeInt>> {
    return this.http.get<AnswerHavanaTypeInt[]>(`${ this.url }/answerhavana.json`, {});
  }
  getGenderType( ): Observable<Array<GenderTypeInt>> {
    return this.http.get<GenderTypeInt[]>(`${ this.url }/genderType.json`, {});
  }
  getStayType( ): Observable<Array<StayTypeInt>> {
    return this.http.get<StayTypeInt []>(`${ this.url }/stayType.json`, {});
  }
}
